import { render, staticRenderFns } from "./CamBreadcrumb.vue?vue&type=template&id=2f932174&scoped=true&"
import script from "./CamBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./CamBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./CamBreadcrumb.vue?vue&type=style&index=0&id=2f932174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f932174",
  null
  
)

export default component.exports